import React, { useState } from "react";
import { FileText, HelpCircle, LockKeyhole, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const sectionIcons = {
  faq: HelpCircle,
  privacy: LockKeyhole,
  terms: FileText,
};

const HelpCenter = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState("faq");
  const Icon = sectionIcons[active];
  const section = t(`helpCenter.${active}`, { returnObjects: true });

  return (
    <main className="page-shell">
      <section className="hero-panel">
        <p className="eyebrow text-gold-400">{t("helpCenter.eyebrow")}</p>
        <h1 className="mt-4 max-w-3xl font-serif text-4xl font-bold sm:text-5xl">{t("helpCenter.title")}</h1>
        <p className="mt-4 max-w-2xl text-green-100">{t("helpCenter.intro")}</p>
      </section>
      <div className="mt-8 grid gap-8 lg:grid-cols-[0.35fr_0.65fr]">
        <nav className="card h-fit p-3" aria-label={t("helpCenter.sectionsLabel")}>
          {Object.entries(sectionIcons).map(([key, ItemIcon]) => (
            <button
              type="button"
              key={key}
              onClick={() => setActive(key)}
              aria-current={active === key ? "page" : undefined}
              className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm font-semibold ${active === key ? "bg-gold-50 text-gold-700" : "text-gray-600 hover:bg-gray-50"}`}
            >
              <ItemIcon size={18} />
              {t(`helpCenter.${key}.label`)}
            </button>
          ))}
        </nav>
        <section className="card p-7 sm:p-9">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gold-50 text-gold-600"><Icon size={22} /></span>
            <div>
              <p className="eyebrow">{section.label}</p>
              <h2 className="mt-2 font-serif text-3xl font-bold text-forest">{section.title}</h2>
              <p className="mt-3 text-sm leading-7 text-gray-600">{section.text}</p>
            </div>
          </div>
          <div className="mt-8 space-y-4">
            {section.items.map(([title, text]) => (
              <article className="rounded-2xl border border-gold-100 p-5" key={title}>
                <h3 className="font-semibold text-forest">{title}</h3>
                <p className="mt-2 text-sm leading-7 text-gray-600">{text}</p>
              </article>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/faq" className="btn-secondary">{t("helpCenter.openFaq")}</Link>
            <Link to="/terms" className="btn-secondary">{t("helpCenter.fullTerms")}</Link>
            <Link to="/privacy" className="btn-secondary">{t("helpCenter.fullPrivacy")}</Link>
          </div>
        </section>
      </div>
      <section className="mt-8 flex items-center gap-3 rounded-2xl bg-gold-50 p-5 text-sm text-gray-600">
        <Mail className="text-gold-600" size={20} />
        <span>{t("helpCenter.personalHelp")} <a href="mailto:support@itontine.com" className="font-semibold text-gold-700">support@itontine.com</a>.</span>
      </section>
    </main>
  );
};

export default HelpCenter;
